module.exports = __webpack_public_path__ + "static/media/009-ptit-caribou_ext-m.ab0f538b.jpeg";